import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderFooter.vue?vue&type=template&id=4c05b125&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-meal-builder-footer.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-meal-builder-footer.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorMealBuilderFooter.vue?vue&type=style&index=0&id=4c05b125&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05b125",
  null
  
)

export default component.exports